import { LanguageEnum } from '../enums';

export interface ForgetPasswordData {
  username: string;
  language: LanguageEnum;
}

export namespace ForgetPasswordData {
  export function mapToApiValue(data: ForgetPasswordData): any {
    const { language, username } = data;
    return {
      username,
      language: language ? LanguageEnum.mapToApiValue(language) : null,
    };
  }
}
